import styled from 'styled-components';

export default styled.div`
  float: right;
  padding-top: 10px;
  height: 54px;

  div {
    width: 88px;
    height: 22px;
  }
`;
